import type { TaskRuleGroup } from '@/services/tasks.service';

/**
 * Badge text for an Appointment Stage rule set to "First Time appointment" (it
 * only adds tasks when the appointment is marked First Time in the scheduler).
 * Null for every other rule.
 *
 * Kept out of TaskRulesPage so it can be tested without mounting the page, whose
 * imports start the whole app.
 */
export function firstAppointmentLabel(
  rule: Pick<TaskRuleGroup, 'triggerType' | 'firstAppointmentOnly'>,
): string | null {
  return rule.triggerType === 1 && rule.firstAppointmentOnly ? 'First Time Only' : null;
}
